import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Gallery() {
  const films = [{
    episode: "12 VIDEOS",
    nameStart: "\n",
    nameItalic: "",
    nameEnd: "",
    caption: "Music videos for original music project Øld Water, edited, directed and produced by Johannes",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/music-vids.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/music-vids.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/music-vids.png",
    alt: "MUSIC VIDS",
    link: {
      href: "https://youtube.com/playlist?list=PLsai2MhJ7NGSoMBXZ7Yu4MA5SgLbqmDFa&si=Biz_gltCs_lF3Zq4",
      newTab: true
    }
  }, {
    episode: "5+ VIDEOS",
    nameStart: "",
    nameItalic: "",
    nameEnd: "",
    caption: "Guitar tutorials and short form content for the Acuerda Escuela music school in Buenos Aires",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Acuerda.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Acuerda.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Acuerda.png",
    alt: "ACUERDA",
    link: {
      href: "https://www.instagram.com/acuerda.escuela?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      newTab: true
    }
  }, {
    episode: "60+ VIDEOS",
    nameStart: "\n",
    nameItalic: "",
    nameEnd: "",
    caption: "Educational shorts series about songwriting, music theory and music production",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Content-final.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Content-final.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Content-final.png",
    alt: "SHORTS",
    link: {
      href: "https://youtube.com/playlist?list=PLsai2MhJ7NGRmGhVlpuSbsXvlTAfwER7V&si=YaFkIDMsY-sV4JOF",
      newTab: true
    }
  }, {
    episode: "5 VIDEOS",
    nameStart: "",
    nameItalic: "",
    nameEnd: "",
    caption: "5 one-shot videos for artists passing through the Myoho Valley peace retreat in Portugal",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Myoho.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Myoho.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Myoho.png",
    alt: "MYOHO",
    link: {
      href: "https://youtube.com/@myohovalleyyt?si=gJoiFt3UaDkbUS9i",
      newTab: true
    }
  }, {
    episode: "10 VIDEOS",
    nameStart: "\n\n",
    nameItalic: "",
    nameEnd: "",
    caption: "10 backing tracks for instrumental practice - counterparts to the ØW Jam Tracks albums",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Jamtracks-final.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Jamtracks-final.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/Jamtracks-final.png",
    alt: "JAM TRACKS",
    link: {
      href: "https://youtube.com/playlist?list=PLsai2MhJ7NGSfMuqWrCBvVbXU70gswjji&si=fkOquRLRJSt9GO4_",
      newTab: true
    }
  }, {
    episode: "6 VIDEOS",
    nameStart: "",
    nameItalic: "",
    nameEnd: "",
    caption: "Showreels in production, composition, muscianship and repertoire",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/showreel-final.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/showreel-final.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/showreel-final.png",
    alt: "SHOWREELS",
    link: {
      href: "https://youtube.com/playlist?list=PLsai2MhJ7NGT9j2YF-MnaNrFX4oL-Prh4&si=e8FWEtU1_nvCuX4p",
      newTab: true
    }
  }, {
    episode: "4 VIDEOS",
    nameStart: "",
    nameItalic: "",
    nameEnd: "",
    caption: "Long form educational series about songwriting, music theory and composition",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/IST-final-1.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/IST-final-1.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/IST-final-1.png",
    alt: "IST",
    link: {
      href: "https://youtube.com/playlist?list=PLsai2MhJ7NGTzZHnPF92X2w_v9JgauF4p&si=3oSohh4xOj8x5sFD",
      newTab: true
    }
  }, {
    episode: "1 VIDEO",
    nameStart: "",
    nameItalic: "",
    nameEnd: "",
    caption: "Colour grading for original artist Sabin Daniels' first ever release",
    src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/The-Light-final.png",
    srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/The-Light-final.png",
    sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/07/The-Light-final.png",
    alt: "THE LIGHT"
  }];
  return <section data-section-id="15052" id="oscilloscopevideogallery" className="text-foreground bg-background/20 ![padding:80px_0px_80px_0px]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-10 items-baseline !w-[340px] md:grid-cols-12 md:gap-12">
          <div className="!w-[340px] md:col-span-7">
            
            <h2 className="font-default text-foreground !text-left !w-[340px] !font-semibold" style={{
            fontSize: "clamp(2rem, 4.6vw, 4rem)",
            lineHeight: 1.02,
            letterSpacing: "-0.022em"
          }}>VIDEO PORTFOLIO</h2>
            <p className="mt-6 text-muted-foreground max-w-md !font-semibold !text-left !w-[340px] !font-sans" style={{
            fontSize: "clamp(0.875rem, 1.1vw, 1rem)",
            lineHeight: 1.6
          }}>JOHANNES IS ALSO A SEASONED VIDEO PRODUCER. HERE ARE A SELECTION OF<div>PROJECTS FEATURING HIS EDITING, COLOUR GRADING, VIDEOGRAPHY, DIRECTING AND PRODUCTION</div></p>
          </div>
          <div className="md:col-span-5">
            
          </div>
        </div>

        <div className="mt-14 md:mt-[56px] grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
          {films.map((film, i) => <div key={i} data-index={i} className="group block relative overflow-hidden rounded-lg shadow-lg" style={{
          aspectRatio: "2 / 3"
        }}>
              <div className="absolute inset-0 overflow-hidden">
                {film.link ? <Link className="w-full h-full block object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04] underline cursor-pointer" {...film.link}>
                    <img src={film.src} data-wvc-srcset={film.srcset} data-wvc-sizes={film.sizes} alt={film.alt} loading="lazy" decoding="async" className="w-full h-full object-cover" />
                  </Link> : <div className="w-full h-full block object-cover transition-transform duration-500 ease-out group-hover:scale-[1.04]">
                    <Link className="w-full h-full object-cover underline cursor-pointer" {...film.link}><img src={film.src} data-wvc-srcset={film.srcset} data-wvc-sizes={film.sizes} alt={film.alt} loading="lazy" decoding="async" /></Link>
                  </div>}
              </div>

              <div className="absolute inset-x-0 bottom-0 h-3/5 pointer-events-none" style={{
            backgroundImage: "linear-gradient(to top, var(--background) 0%, var(--background) 15%, transparent 100%)"
          }} aria-hidden="true" />

              <div className="absolute inset-0 rounded-lg pointer-events-none border opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
            borderColor: "var(--secondary)"
          }} aria-hidden="true" />

              <div className={`${film.episodeClassName || ""} absolute inset-x-0 bottom-0 p-6 md:p-7`}>
                <p className="font-mono font-normal mb-4 transition-colors duration-200" style={{
              fontSize: "clamp(0.75rem, 0.8vw, 0.8125rem)",
              letterSpacing: "0.04em",
              lineHeight: 1.4,
              color: "var(--muted-foreground)"
            }}>
                  <span className="group-hover:text-[var(--secondary)] transition-colors duration-200">
                    {film.episode}
                  </span>
                </p>
                <h3 className="font-default font-medium text-foreground mb-3" style={{
              fontSize: "clamp(1.375rem, 2.2vw, 1.875rem)",
              lineHeight: 1.15,
              letterSpacing: "-0.015em"
            }}>
                  {film.nameStart}
                  <em className="font-default italic font-medium">
                    {film.nameItalic}
                  </em>
                  {film.nameEnd}
                </h3>
                <p className="!font-medium !font-mono" style={{
              fontSize: "clamp(0.875rem, 1.1vw, 1rem)",
              lineHeight: 1.3,
              color: "var(--muted-foreground)"
            }}>
                  {film.caption}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-20 md:mt-24 flex justify-center">
          <Link to="https://www.youtube.com/@OldWaterMusic" newTab className="group inline-flex items-center gap-2 px-6 py-3 rounded-lg text-secondary-foreground transition-colors duration-200 font-default font-medium !bg-[rgba(239,67,67,1)] hover:bg-secondary/90">
            <span className="!text-[rgba(255,255,255,1)] !font-semibold">More on Youtube</span>
            <img src="https://skilled-urchin.10web.cloud/wp-content/uploads/2026/06/580b57fcd9996e24bc43c545.png" className="lucide lucide-arrow-right size-4 transition-transform duration-200 ease-out group-hover:translate-x-1.5 !bg-[rgba(255,255,255,0)]" alt="Youtube" />
          </Link>
        </div>
      </div>
    </section>;
}